import React, { Component } from "react";
import { getStripeClientID } from "../../../lib/config";
import "./connect_button.css";
import { stringify } from "qs";
import get from "lodash/get";

class StripeConnection extends Component {
  render() {
    const stripeURL = getStripeURL(this.props.user);
    return (
      <div className="stripe-connection-wrapper">
        <div className="stripe-connection__button">
          <p>
            <a href={stripeURL} className="connect-button">
              <span>Connect with Stripe</span>
            </a>
          </p>
          <p className="stripe-connection__button-description" />
        </div>
      </div>
    );
  }
}

export const getStripeURL = user => {
  var stripeClientID = getStripeClientID();
  var params = {
    response_type: "code",
    client_id: stripeClientID,
    scope: "read_write",
    state: get(user, "securityToken"),
    suggested_capabilities: ["card_payments", "transfers", "tax_reporting_us_1099_misc"],
    stripe_user: {
      email: get(user, "email"),
      first_name: get(user, "firstName"),
      last_name: get(user, "lastName"),
    },
  };

  if (get(user, "phoneNumber")) {
    params.stripe_user.phone_number = get(user, "phoneNumber");
  }

  return (
    "https://connect.stripe.com/express/oauth/authorize?" +
    stringify(params, { arrayFormat: "brackets" })
  );
};
export default StripeConnection;
